import FakeGeneralEnrollmentService from './fake/FakeGeneralEnrollmentService';
import FakeProjectEnrollmentService from './fake/FakeProjectEnrollmentService';
import FakeNetworkEnrollmentService from './fake/FakeNetworkEnrollmentService';

export default {
  general: FakeGeneralEnrollmentService,
  project: FakeProjectEnrollmentService,
  network: FakeNetworkEnrollmentService
};
